<template>
	<div id="App">
		<div id="AppWrap">
			<b-navbar
				id="headernav"
				toggleable="lg"
				type="light"
				variant="light"
			>
				<b-navbar-brand  @click="$root.store.setRoute('/home')">
					<div class="christmas snow-container" v-if="isChristmas">
						<div class="snow-text" style="animation-delay:.1s">*</div>
						<div class="snow-text" style="animation-delay:.5s;left: 50px;">*</div>
						<div class="snow-text" style="animation-delay:.3s;left: 100px;">*</div>
						<div class="snow-text" style="animation-delay:.8s;left: 160px;">*</div>
						<div class="snow-text" style="animation-delay:.6s;left: 190px;">*</div>
					</div>
					<img
						id="logo"
						:src="logoToShow"

						class="d-inline-block align-top"
					/>
				</b-navbar-brand>
				

				<b-collapse id="nav-collapse" is-nav>
					<b-navbar-nav>
						<b-nav-item
							v-if="$hasModule('realtime')"
							href="/operation/live"
							@click="setRoute"
						>
							<b-spinner variant="success" small type="grow" />
							Tiempo real</b-nav-item
						>
						<b-nav-item
							href="/operation"
							v-if="$hasModule('operation')"
							@click="setRoute"
							><md-icon icon="directions_car" />
							Operacion</b-nav-item
						>
						<b-nav-item
							href="/coordination"
							v-if="$hasModule('coordination')"
							@click="setRoute"
							><md-icon icon="directions_car" />
							Coordinacion</b-nav-item
						>
						<b-nav-item
							href="/"
							v-if="$hasModule('reservation')"
							@click="setRoute"
							><md-icon icon="directions_car" />
							Reservas</b-nav-item
						>
						<b-nav-item-dropdown v-if="showRates">
							<template v-slot:button-content>
								<md-icon icon="local_atm" /> Tarifas
							</template>
							<b-dropdown-item
								href="/rate-plans"
								v-if="$hasModule('rates')"
								@click="setRoute"
								>Planes tarifarios</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('quote')"
								@click="$bvModal.show('quote-modal')"
								>Cotizador</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('flightCalculator')"
								href="/quote/flights"
								@click="setRoute"
								>Cotizador de vuelos</b-dropdown-item
							>
							<b-dropdown-item
								href="/vivaaerobus"
								@click="setRoute"
								>Viva Aerobus Widget</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('pointOfSale')"
								href="/point-of-sales"
								@click="setRoute"
								>Puntos de venta</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('supplierCost')"
								href="/suppliers/prices"
								@click="setRoute"
								>Costos de proveedor</b-dropdown-item
							>

							<b-dropdown-item
								href="/sales-channels/prices"
								@click="setRoute"
								>Costos de canal de venta</b-dropdown-item
							>
						</b-nav-item-dropdown>
						<b-nav-item-dropdown v-if="showSettings">
							<template #button-content>
								<md-icon icon="settings" /> Configuraciones
							</template>
							<b-dropdown-item
								href="/destinations"
								v-if="$hasModule('city')"
								@click="setRoute"
								>Ciudades</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('reasonState')"
								href="/reason-states"
								@click="setRoute"
								>Razones de Estado</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('place')"
								href="/places"
								@click="setRoute"
								>Destinos</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('airport')"
								href="/airport"
								@click="setRoute"
								>Aeropuertos</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('meetingInstructions')"
								href="/meeting-instructions"
								@click="setRoute"
								>Instrucciones meet & greet</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('channel')"
								href="/sales-channels"
								@click="setRoute"
								>Canales</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('salesChannelRules')"
								href="/sales-channels/rules"
								@click="setRoute"
								>Reglas de canal</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('supplier')"
								href="/suppliers"
								@click="setRoute"
								>Proveedores</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('serviceType')"
								href="/service-types"
								@click="setRoute"
								>Tipos de servicio</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('serviceTypesCategories')"
								href="/service-categories"
								@click="setRoute"
								>Categorias de servicio</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('additionalService')"
								href="/additional-services"
								@click="setRoute"
								>Servicios adicionales</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('zone')"
								href="/zoned-areas"
								@click="setRoute"
								>Zonas de operación</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('changelog')"
								href="/change-logs"
								@click="setRoute"
								>Historial de cambios</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasPermission('stopSale.show')"
								href="/stop-sales"
								@click="setRoute"
								>Cierre de ventas</b-dropdown-item
							>
							<b-dropdown-item
								href="/mapping"
								@click="setRoute"
								>Mapeos</b-dropdown-item>
							<b-dropdown-item
								v-if="
									$hasModule('user') || $hasModule('usersass')
								"
								href="/users"
								@click="setRoute"
								><md-icon icon="supervisor_account" />
								Usuarios</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('profile')"
								href="/profiles"
								@click="setRoute"
							>
								Perfiles</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasPermission('reservation.apiData')"
								@click="$refs['refApiReservations'].show()"
								>Reservaciones via API</b-dropdown-item
							>
							<b-dropdown-divider></b-dropdown-divider>
							<div class="dropdown-submenu">
								<button class="dropdown-item dropdown-toggle">
									<md-icon icon="smart_toy" /> Automatizaciones
								</button>
								<div class="dropdown-menu">
									<a class="dropdown-item" href="/evidences" @click="setRoute"
										v-if="$hasModule('suppliersEvidences')">
										Evidencias
									</a>
									<a class="dropdown-item" href="/event-subscriptions" @click="setRoute"
										v-if="$hasModule('eventsSubscriptions')">
										Subscripción de eventos
									</a>
								</div>
							</div>
						</b-nav-item-dropdown>
						<b-nav-item-dropdown v-if="showReport">
							<template #button-content> Reportes </template>
							<b-dropdown-item
								v-if="$hasModule('report')"
								href="/reports"
								@click="setRoute"
								><md-icon icon="data_usage" />
								Reportes</b-dropdown-item
							>
							<b-dropdown-item
								v-if="$hasModule('dashboard')"
								href="/dashboard"
								@click="setRoute"
								><md-icon icon="pie_chart" />
								Dashboard</b-dropdown-item
							>
							<b-dropdown-item
								href="/allotment"
								@click="setRoute"
								><md-icon icon="calendar_today" />
								Allotment</b-dropdown-item
							>
							<b-dropdown-item
								href="/rate-plans/calendar"
								@click="setRoute"
								><md-icon icon="timeline" />
								Distribucion de tarifas</b-dropdown-item
							>
						</b-nav-item-dropdown>
						<b-nav-item
							v-if="$hasPermission('flight.schedule.show')"
							href="#"
							@click="$refs['refTrackingFlight'].show()"
						><md-icon icon="flight" /> Vuelos</b-nav-item>

						<b-nav-item href="/imports" v-if="$hasPermission('reservations.import')">
							<md-icon icon="upload_file"/>Importar
						</b-nav-item>

						</b-navbar-nav>
						
					<b-navbar-nav class="ml-auto">
						
						<b-avatar
							variant="primary"
							:text="user.firstName.charAt(0)"
						></b-avatar>
						<b-nav-item-dropdown right>
							<div class="d-flex flex-row px-3 py-2 align-items-center">
                <b-avatar
                  variant="primary"
                  :text="user.firstName.charAt(0)"
                ></b-avatar>
                <div class="flex-grow-1 pl-2">
                  <h5 class="m-0">
                    {{ user.firstName + " " + user.lastName }}
                  </h5>
                  <h6 class="text-black-50">{{ user.email }}</h6>
                </div>
              </div>
							<b-dropdown-item href="/profile" @click="setRoute"
								><md-icon icon="account_circle" />
								Perfil</b-dropdown-item
							>
							<b-dropdown-divider />
							<b-dropdown-item href="#" @click="logout"
								>Salir <md-icon icon="time_to_leave"/><md-icon
									icon="directions_run"
							/></b-dropdown-item>
						</b-nav-item-dropdown>
						
					</b-navbar-nav>
				</b-collapse>

				<Highlights class="mr-2 mt-1"></Highlights>
				<b-navbar-toggle target="#" @click="menu = true">
					<template #default="{ expanded }">
						<md-icon
							class="menu-icon"
							v-if="expanded"
							icon="menu_open"
						></md-icon>
						<md-icon class="menu-icon" v-else icon="menu"></md-icon>
					</template>
				</b-navbar-toggle>
			</b-navbar>
			
			<div v-if="showAlert">
				<b-alert show variant="warning" class="text-center p-lg-4">
					<b>
						<md-icon icon="warning" />ENTORNO DE PRUEBAS, cualquier
						cambio realizado no se vera reflejado en el sistema de
						produccion
					</b>
				</b-alert>
			</div>
		
			<slot></slot>
		</div>

		<b-sidebar title="Menu" shadow v-model="menu" backdrop >
			<nav class="mb-3">
				<b-nav vertical>
					<b-nav-item
						v-if="$hasModule('realtime')"
						href="/operation/live"
						@click="setRoute"
					>
						<b-spinner variant="success" small type="grow" /> Tiempo
						real</b-nav-item
					>
					<b-nav-item
						v-if="$hasModule('operation')"
						href="/operation"
						@click="setRoute"
						><md-icon icon="directions_car" /> Operacion</b-nav-item
					>
					<b-nav-item
						href="/coordination"
						@click="setRoute"
						v-if="$hasModule('coordination')"
						><md-icon icon="directions_car" />
						Coordinacion</b-nav-item
					>
					<b-nav-item
						v-if="$hasModule('reservation')"
						href="/"
						@click="setRoute"
						><md-icon icon="directions_car" /> Reservas</b-nav-item
					>

					<b-nav-item v-if="showRates" @click="ratesMenu = !ratesMenu"
						><md-icon icon="local_atm" /> Tarifas
						<md-icon
							:icon="ratesMenu ? 'expand_less' : 'expand_more'"
						/>
					</b-nav-item>
					<b-collapse v-model="ratesMenu" class="ml-4">
						<b-nav-item
							v-if="$hasModule('rates')"
							href="/rate-plans"
							@click="setRoute"
							>Planes tarifarios</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('quote')"
							@click="$bvModal.show('quote-modal')"
							>Cotizador</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('flightCalculator')"
							href="/quote/flights"
							>Cotizador de vuelos</b-nav-item
						>
						<b-nav-item
							href="/vivaaerobus"
							@click="setRoute"
							>Viva Aerobus Widget</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('pointOfSale')"
							href="/point-of-sales"
							@click="setRoute"
							>Puntos de venta</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('supplierCost')"
							href="/suppliers/prices"
							@click="setRoute"
							>Costos proveedor</b-nav-item
						>
						<b-nav-item
							href="/sales-channels/prices"
							@click="setRoute"
							>Costos de canal de venta</b-nav-item
						>
					</b-collapse>

					<b-nav-item
						v-if="showSettings"
						@click="configMenu = !configMenu"
						><md-icon icon="settings"/> Configuraciones
						<md-icon
							:icon="configMenu ? 'expand_less' : 'expand_more'"
					/></b-nav-item>
					<b-collapse v-model="configMenu" class="ml-4">
						<b-nav-item
							v-if="$hasModule('city')"
							href="/destinations"
							@click="setRoute"
							>Ciudades</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('reasonState')"
							href="/reason-states"
							@click="setRoute"
							>Razones de Estado</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('place')"
							href="/places"
							@click="setRoute"
							>Destinos</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('airport')"
							href="/airport"
							@click="setRoute"
							>Aeropuertos</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('meetingInstructions')"
							href="/meeting-instructions"
							@click="setRoute"
							>Instrucciones meet & greet</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('channel')"
							href="/sales-channels"
							@click="setRoute"
							>Canales</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('salesChannelRules')"
							href="/sales-channels/rules"
							@click="setRoute"
							>Reglas de canales</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('supplier')"
							href="/suppliers"
							@click="setRoute"
							>Proveedores</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('serviceType')"
							href="/service-types"
							@click="setRoute"
							>Tipos de servicio</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('serviceTypesCategories')"
							href="/service-categories"
							@click="setRoute"
							>Categorias de servicio</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('additionalService')"
							href="/additional-services"
							@click="setRoute"
							>Servicios adicionales</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('zone')"
							href="/zoned-areas"
							@click="setRoute"
							>Zonas de operación</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('changelog')"
							href="/change-logs"
							@click="setRoute"
							>Historial de cambios</b-nav-item
						>
						<b-nav-item
							v-if="$hasPermission('stopSale.show')"
							href="/stop-sales"
							@click="setRoute"
							>Cierre de ventas</b-nav-item
						>
						<b-nav-item
							href="/mapping"
							@click="setRoute"
							>Mapeos</b-nav-item>
						<b-nav-item
							v-if="$hasModule('user') || $hasModule('usersass')"
							href="/users"
							@click="setRoute"
							><md-icon icon="supervisor_account" />
							Usuarios</b-nav-item
						>
						<b-nav-item
							v-if="$hasModule('profile')"
							href="/profiles"
							@click="setRoute"
							>Perfiles</b-nav-item
						>
						<b-nav-item
							v-if="$hasPermission('reservation.apiData')"
							@click="$refs['refApiReservations'].show()"
							>Reservaciones via API</b-nav-item
						>
						<b-dropdown-divider></b-dropdown-divider>
						<b-nav-item @click="automationsMenu = !automationsMenu">
							<md-icon icon="smart_toy"/> Automatizaciones
							<md-icon :icon="automationsMenu ? 'expand_less' : 'expand_more'"/>
						</b-nav-item>
						<b-collapse v-model="automationsMenu" class="ml-4">
							<b-nav-item
								v-if="$hasModule('suppliersEvidences')"
								href="/evidences"
								@click="setRoute"
								>Evidencias</b-nav-item
							>

							<b-nav-item
								v-if="$hasModule('eventsSubscriptions')"
								href="/event-subscriptions"
								@click="setRoute"
								>Subscripción de eventos</b-nav-item
							>
						</b-collapse>
					</b-collapse>

					<b-nav-item
						v-if="showReport"
						@click="reportsMenu = !reportsMenu"
						><md-icon icon="settings"/> Reportes
						<md-icon
							:icon="reportsMenu ? 'expand_less' : 'expand_more'"
					/></b-nav-item>
					<b-collapse v-model="reportsMenu" class="ml-4">
						<b-nav-item href="/reports" @click="setRoute"
							><md-icon icon="data_usage" /> Reportes</b-nav-item
						>
						<b-nav-item href="/dashboard" @click="setRoute"
							><md-icon icon="pie_chart" /> Dashboard</b-nav-item
						>
						<b-nav-item href="/allotment" @click="setRoute"
							><md-icon icon="calendar_today" /> Allotment</b-nav-item
						>
						<b-nav-item href="/rate-plans/calendar" @click="setRoute"
							><md-icon icon="timeline" /> Distribucion de tarifas</b-nav-item
						>
					</b-collapse>
					<b-nav-item v-if="$hasPermission('flight.schedule.show')"  href="#" @click="$refs['refTrackingFlight'].show()">
            <md-icon icon="flight" />Vuelos
          </b-nav-item>

					<b-nav-item to="/imports"
						v-if="$hasPermission('reservations.import')"
						><md-icon icon="upload_file" />
						Importar</b-nav-item
						>

					<b-dropdown-divider></b-dropdown-divider>
					<b-nav-item href="/profile" @click="setRoute"
						><md-icon icon="account_circle" /> Perfil</b-nav-item
					>
					<b-nav-item href="#" @click="logout"
						>Salir <md-icon icon="time_to_leave"/><md-icon
							icon="directions_run"
					/></b-nav-item>
				</b-nav>
			</nav>
		</b-sidebar>
		<ButtonHighlights></ButtonHighlights>

    <footer>
      <img :src="logo" />
    </footer>
    <b-modal
      id="warning-alert"
      size="sm"
      body-class="position-static"
      hide-header
      centered
      no-fade
    >
      {{ warningProps.message || "¿Desea continuar con esta acción?" }}
      <template #modal-footer="{ close }">
        <b-button
          :disabled="warningProps.loading"
          @click="close()"
          type="button"
          class="float-right"
        >
          Cancelar
        </b-button>
        <b-button
          :disabled="warningProps.loading"
          @click="
            (event) =>
              warningProps.okAction(event, warningProps.setLoading, close)
          "
          type="button"
          variant="primary"
          class="float-right"
        >
          <span v-if="!warningProps.loading">Continuar</span>
          <span v-else><b-spinner small></b-spinner> Procesando...</span>
        </b-button>
      </template>
    </b-modal>

    <!-- modal vuelos -->
    <b-modal
      hide-footer
      ref="refTrackingFlight"
      size="lg"
      title="Seguimiento de vuelos"
    >
      <TrackingFlightModal
        @closeModal="
          () => {
            $refs['refTrackingFlight'].hide();
          }
        "
      />
    </b-modal>

	<b-modal
      hide-footer
      ref="refApiReservations"
      size="lg"
      title="Busqueda de reservas de API"
    >
      <ApiReservationsModal
        @closeModal="
          () => {
            $refs['refTrackingFlight'].hide();
          }
        "
      />
    </b-modal>

    <b-modal
      id="quote-modal"
      hide-header
      title="Quote"
      ok-only
      ok-title="CLOSE"
      body-class="position-static"
      size="xl"
    >
      <Quote />
    </b-modal>


	
	
  </div>
</template>

<script>
import ApiReservationsModal from "./components/ApiReservationsModal.vue";
import TrackingFlightModal from "./components/TrackingFlightModal.vue";
import logo from "../../../assets/logo-sc-azul.png";
import logoNavidad from "../../../assets/logo-sc-navidad.png";
import logoHalloween from "../../../assets/logo-sc-halloween.png";
import Quote from "./../rates/Quote";
import moment from 'moment'
import Highlights from "@/components/sections/modules/highlights/Main"
import ButtonHighlights from "@/components/sections/modules/highlights/Button"
export default {
	components: { TrackingFlightModal, Quote, ApiReservationsModal,Highlights,ButtonHighlights },
	data() {
		return {
			logo,
			logoNavidad,
			logoHalloween,
			menu: false,
			ratesMenu: false,
			configMenu: false,
			reportsMenu: false,
			automationsMenu: false
		};
	},
	methods: {
		logout() {
			this.$root.store.clearUser();
			this.$root.store.setRoute("/login");
		},
		setRoute(evt) {
			this.$root.setRouteEvt(evt);
		}
	},
	computed: {
		user() {
			return this.$root.store.state.currentUser;
		},
		warningProps() {
			return this.$root.warningProps;
		},
		alertProps() {
			return this.$root.alertProps;
		},
		showAlert() {
			return process.env.NODE_ENV !== "production";
		},
		showSettings() {
			return this.$hasModuleGroup([
				"city",
				"reasonState",
				"place",
				"airport",
				"meetingInstructions",
				"channel",
				"salesChannelRules",
				"eventsSubscriptions",
				"supplier",
				"serviceType",
				"additionalService",
				"zone",
				"changelog",
				"stopSale",
				"user",
				"usersass",
				"profile"
			]);
		},
		showRates() {
			return this.$hasModuleGroup([
				"rates",
				"quote",
				"flightCalculator",
				"pointOfSale",
				"supplierCost"
			]);
		},
		showReport() {
			return this.$hasModuleGroup(["report", "dashboard"]);
		},
		isChristmas(){
			try{
				let month = moment().format("MM");
				if(month==12){
					return true;
				}
				return false;
			}catch(err){
				return false;
			}
		},
		logoToShow(){
			try{
				let month = moment().format("MM");
				if(month==12){//navidad
					return this.logoNavidad
				}else if(month==10){//hallowen
					return this.logoHalloween;
				}else{//normal
					return this.logo
				}
			}catch(err){
				console.error(err)
			}
			return this.logo;
		}
	}
};
</script>

<style>
html,
body {
	background: #e3e1fd;
}
.container {
	max-width: 1500px;
	margin-bottom: 20px;
}
.box {
	background: #fff;
	padding: 3em 2em;
}
.material-icons {
	font-size: 130%;
	vertical-align: text-bottom !important;
}
.col-form-label {
	padding-bottom: 0;
}
.form-group {
	margin-bottom: 0.3rem;
}
.modal hr {
	margin-bottom: 0.5rem;
	margin-top: 0.5rem;
}
.btn-group-sm > .btn,
.btn-sm {
	padding: 0.15rem 0.4rem;
}
.modal-header,
.modal-footer {
	padding: 0.5em 1em;
}
#headernav .navbar-nav .nav-link {
	color: #d1d1ed !important;
}
.dropdown-submenu {
	position: relative;
}
.dropdown-submenu > .dropdown-menu {
	top: 0;
	left: 100%;
	margin-top: -1px;
	display: none;
}
.dropdown-submenu:hover > .dropdown-menu {
	display: block;
}
.dropdown-submenu > .dropdown-toggle::after {
	content: " ▸";
	float: right;
	margin-left: 10px;
	border: none;
}
#headernav {
	background-color: #021d3e !important;
	margin-bottom: 20px;
	border-bottom: 2px solid #d1d1ed;
}
.container > .box {
	border: 2px solid #021d3e;
}

/* new status color */
.table-partialCancellation:hover {
	background-color: #fd9b49 !important;
}
.table-partialCancellation tbody + tbody,
.table-partialCancellation td,
.table-partialCancellation th,
.table-partialCancellation thead th {
	border-color: #db7849;
}
.table-partialCancellation,
.table-partialCancellationy > td,
.table-partialCancellation > th {
	background-color: #ffab65 !important;
}
.badge-partialCancellation,
.btn-partialCancellation {
	background-color: #fd7e14;
	color: black;
}

/* Base styles MODAL XL */
.sc-modal-xl {
    max-width: 95vw; /* Default for very small screens */
}

.sidebar-assignation{
	min-width: 450px !important
}

/* Medium to large screens */
@media (min-width: 600px) and (max-width: 1899px) {
    .sc-modal-xl {
        max-width: 90vw;
    }
}

/* Extra large screens */
@media (min-width: 1900px) {
    .sc-modal-xl {
        max-width: 80vw;
    }
}


@media (min-width: 1200px){
	.sidebar-assignation{
		width: 30vw !important;
	}
}
</style>

<style scoped>
#App {
	position: relative;
	min-height: 100vh;
	overflow: hidden;
}
.menu-icon {
	color: #fff;
}
#AppWrap {
	padding-bottom: 5rem;
}
#logo {
	max-width: 200px;
}
footer {
	position: absolute;
	bottom: 0;
	width: 100%;
	text-align: center;
	padding: 10px;
	height: 5rem;
	background-color: #021d3e;
}
footer img {
	max-height: 100%;
}
</style>

<style scoped>
.snow-container {
	/*height: 100vh;*/ /* Adjust the height as needed */
	overflow: hidden;
}

.snow-text {
	animation: marqueeDown 2s linear infinite; /* Adjust animation duration as needed */
	position: absolute;
	color: whitesmoke;
}

@keyframes marqueeDown {
	0% {
	transform: translateY(-20%);
	}
	100% {
	transform: translateY(50%);
	}
}
</style>
